var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24999 18L6.84999 19.05C6.19075 19.5444 5.24999 19.074 5.24999 18.25V16.75C5.24999 16.1977 4.80228 15.75 4.24999 15.75H2.25C1.85217 15.75 1.47064 15.5919 1.18934 15.3106C0.908035 15.0293 0.75 14.6478 0.75 14.25V2.25C0.75 1.85217 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85217 0.75 2.25 0.75H18.75C19.1478 0.75 19.5293 0.908035 19.8106 1.18934C20.0919 1.47064 20.25 1.85217 20.25 2.25V6.71484",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25H15.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.75H8.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 17.75C23.25 18.3023 22.8023 18.75 22.25 18.75H21.25C20.6977 18.75 20.25 19.1977 20.25 19.75V20.8358C20.25 21.7267 19.1729 22.1729 18.5429 21.5429L16.0429 19.0429C15.8554 18.8554 15.601 18.75 15.3358 18.75H12.25C11.6977 18.75 11.25 18.3023 11.25 17.75V10.75C11.25 10.1977 11.6977 9.75 12.25 9.75H22.25C22.8023 9.75 23.25 10.1977 23.25 10.75V17.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/FeedbackIcon.2983096a9f318ed5a4f4ad9a4ef6589f.svg";
export { ForwardRef as ReactComponent };